import Logo from "../components/Logo";
import {NavLink, useNavigate} from "react-router-dom";
import {clearautoline, memberlineauto} from "../store/user";
import {useDispatch, useSelector} from "react-redux";
import { useRef, useEffect, useState} from "react";
import { WEBTOKEN, LG, WEBNAME, VDO } from '../store/config'
import { Spinner } from "react-bootstrap";
import VedioMoal from './Lotto/ModalVDO'
import PageHeader from "../components/PageHeader";
function Login() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [show, setShow] = useState(false)
    const showVDO = () => {
     setShow(true)
    }
    const user = useSelector(state => state.user)
    const { linedata } = user
    
    const register = async () => {
        return navigate("/contact");
    }
    /*
    const signIn = async () => {
        await dispatch(login());
        return navigate("/");
    }
    */

    useEffect(()=> {
        if(localStorage.getItem('access_token')) {
            return navigate("/");
        }
    }, [])
    const txtusername = useRef(null)
  
    const cleardata = () => {
        txtusername.current.value = ''
        dispatch(clearautoline())
    }
    const signIn = async () => {

        const username = txtusername.current.value;
        if(!username){
            txtusername.current.focus()
        } else {
            const data = {
                data:username
            }
            if(user?.isLoadingLogin === false) {
                dispatch(memberlineauto(data));
            }
            
        }
        
        /*
        await dispatch(login());
        return navigate("/");
        */
    }

    return (
        <div className={'container'}>
            <div className={'row justify-content-center align-items-center min-vh-100 py-5'}>
                <div className={'col-12 col-md-auto w-100'} style={{maxWidth: '450px'}} data-aos="fade-up">

                    <div className={'text-center d-flex justify-content-between'}>
                
                    </div>

                    <div className={'text-center'}>
                   
                
                      
                   </div>

                    <div className={'card card-green mt-4 py-3'}>
                        <div className={'card-body'}>
                            <h3 className={'text-center'}>
                                ป้อนเลข
                            </h3>

                            <div className={'text-center mb-4 text-secondary'}>
                            
                            </div>

                            <div className={'d-flex gap-2 mb-3'}>
                                <textarea rows={12} ref={txtusername} className={'form-control form-control-lg input-custom custom__input ip20001'}
                                       placeholder={'ใส่เลข'}/>
                            </div>
                            <div className={'text-center d-flex justify-content-between'}>
                
{
    linedata?.sum && <div className={' btn btn-secondary btn-lg m-2'}>ยอด : {linedata?.sum} บาท</div>
}
{
    linedata?.count && <div className={' btn btn-secondary btn-lg m-2'}>เลข : {linedata?.count} ตัว</div>
}

</div>
                            {
                        user.item?.status == 3 && <div className="text-danger text-center">ข้อมูลไม่ถูกต้อง</div>
                }

                            <div className={'text-center mb-3'}>
                                {
                                    user?.isLoadingLogin === true ? <div className={'w-100 btn btn-primary btn-lg'}>คำนวนยอด <Spinner size="sm" /></div> : <div className={'w-100 btn btn-primary btn-lg'} onClick={signIn}>คำนวนยอด</div>
                                }
                                
                            </div>
                            <div className={'text-center mb-3'}>
                            <div className={'w-100 btn btn-danger btn-lg'} onClick={cleardata}>เคลียร์</div>
                                
                            </div>

                         
                            
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default Login;
